import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getExecutiveSummary } from '../api/executiveSummaryApi'

/** Yönetici Özeti verisi (dil değişince ad'lar için yeniden çeker). id null ise sorgu çalışmaz. */
export function useExecutiveSummary(id: number | null) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['activity-executive-summary', id, i18n.language],
    queryFn: () => getExecutiveSummary(id as number),
    enabled: id != null,
  })
}
